import React, { useState } from "react";
import { Row, Col, Card, Table, Button, Dropdown, Form, InputGroup } from "react-bootstrap";
import { FaPlus, FaRedo, FaFilter, FaSort, FaSearch, FaEye, FaTrashAlt, FaEdit } from "react-icons/fa";

const initialData = [
  {
    partnerName: "Asif",
    accountName: "Account Alpha",
    date: "2024-01-15",
    billAmount: "$250",
    status: "In Progress",
  },
  {
    partnerName: "Bilal",
    accountName: "Account Beta",
    date: "2024-02-10",
    billAmount: "$180",
    status: "Success",
  },
  {
    partnerName: "Cynthia",
    accountName: "Account Gamma",
    date: "2024-03-05",
    billAmount: "$300",
    status: "Failed",
  },
];

const PaymentHistoryTable = () => {
  const [data, setData] = useState(initialData);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredData = data.filter(
    (item) =>
      item.partnerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.accountName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return direction === "ascending" ? -1 : 1;
      if (a[key] > b[key]) return direction === "ascending" ? 1 : -1;
      return 0;
    });
    setSortConfig({ key, direction });
    setData(sortedData);
  };

  const handleAction = (action, index) => {
    alert(`${action} action for row ${index + 1}`);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + itemsPerPage);

  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <Button variant="primary" className="d-flex align-items-center">
                <FaPlus className="me-2" /> Payment History
              </Button>
              <div className="d-flex align-items-center">
                <Button variant="light" className="me-2">
                  <FaFilter />
                </Button>
                <Button variant="light" className="me-2">
                  <FaRedo />
                </Button>
                <InputGroup style={{ width: "300px" }}>
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    className="rounded"
                  />
                </InputGroup>
              </div>
            </Card.Header>
            <Card.Body>
              <div
                className="table-responsive border border-secondary rounded"
                style={{ padding: "1rem" }}
              >
                <Table hover>
                  <thead>
                    <tr>
                      <th onClick={() => handleSort("partnerName")}>
                        Partner Name <FaSort />
                      </th>
                      <th onClick={() => handleSort("accountName")}>
                        Account Name <FaSort />
                      </th>
                      <th onClick={() => handleSort("date")}>
                        Date <FaSort />
                      </th>
                      <th onClick={() => handleSort("billAmount")}>
                        Bill Amount <FaSort />
                      </th>
                      <th onClick={() => handleSort("status")}>
                        Status <FaSort />
                      </th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.map((item, index) => (
                      <tr key={index}>
                        <td className="d-flex align-items-center">
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                              backgroundColor: "#007bff",
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "bold",
                              marginRight: "10px",
                            }}
                          >
                            {item.partnerName[0]}
                          </div>
                          {item.partnerName}
                        </td>
                        <td>{item.accountName}</td>
                        <td>{item.date}</td>
                        <td>{item.billAmount}</td>
                        <td>
                          <span
                            className={`badge ${
                              item.status === "Success"
                                ? "bg-success"
                                : item.status === "Failed"
                                ? "bg-danger"
                                : "bg-warning"
                            }`}
                          >
                            {item.status}
                          </span>
                        </td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              size="sm"
                              className="border-0"
                            >
                              Actions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item onClick={() => handleAction("View", index)}>
                                <FaEye className="me-2 text-primary" /> View
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => handleAction("Edit", index)}>
                                <FaEdit className="me-2 text-info" /> Edit
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => handleAction("Delete", index)}>
                                <FaTrashAlt className="me-2 text-danger" /> Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {!filteredData.length && (
                  <p className="text-center">No results found.</p>
                )}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    Showing {startIndex + 1} to{" "}
                    {Math.min(startIndex + itemsPerPage, filteredData.length)} of{" "}
                    {filteredData.length} entries
                  </div>
                  <div>
                    {[...Array(pageCount).keys()].map((page) => (
                      <Button
                        key={page}
                        variant="light"
                        className={`me-1 ${
                          currentPage === page + 1 ? "active" : ""
                        }`}
                        onClick={() => setCurrentPage(page + 1)}
                      >
                        {page + 1}
                      </Button>
                    ))}
                  </div>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PaymentHistoryTable;
